'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertIconXs } from '@lichtblick/icons/svg/alert/alert-xs';
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { FieldFooter } from '@lichtblick/photon/atoms/field-footer';
import { Li, Ul } from '@lichtblick/photon/atoms/list/list';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { Checkbox } from '@lichtblick/photon/molecules/checkbox';
import { Textfield } from '@lichtblick/photon/molecules/textfield';
import classNames from 'classnames';
import { useActionState, useEffect, useRef, useState } from 'react';
import { RichText } from '../../helpers/RichText';
import { InfoTeaser } from '../info-teaser/info-teaser';
import { submitForm } from './actions';
import styles from './kwk-form.module.scss';
const richTextMapperOverride = {
    p: ({ children })=>/*#__PURE__*/ _jsx(Text, {
            renderAs: "p",
            size: "l",
            spacing: true,
            children: children
        }),
    ul: ({ children })=>/*#__PURE__*/ _jsx(Ul, {
            className: styles.ul,
            children: children
        }),
    li: ({ children })=>/*#__PURE__*/ _jsx(Li, {
            className: styles.li,
            children: children
        })
};
const INCORRECT_DATA_ERROR = 'Hier stimmt was nicht.';
export const KWKForm = ({ aknowledgement, infoTeaser, intro, optin, privacyNote, successTeaser })=>{
    const containerRef = useRef(null);
    const formRef = useRef(null);
    const [contractIdChanged, setContractIdChanged] = useState(false);
    const [meterIdChanged, setMeterIdChanged] = useState(false);
    const [state, dispatch, pending] = useActionState(submitForm, {
        submitted: false,
        inputs: {
            contractId: '',
            counterNumber: '',
            emailAddress: '',
            optIn: false
        }
    });
    useEffect(()=>{
        if (!state.submitted && state.errors?.length) {
            setContractIdChanged(false);
            setMeterIdChanged(false);
            formRef.current?.scrollIntoView({
                block: 'center'
            });
        }
    }, [
        state
    ]);
    useEffect(()=>{
        if (!state.submitted) {
            return;
        }
        containerRef.current?.scrollIntoView({
            block: 'center'
        });
    }, [
        state.submitted
    ]);
    if (state.submitted) {
        return /*#__PURE__*/ _jsx("div", {
            ref: containerRef,
            children: /*#__PURE__*/ _jsx(InfoTeaser, {
                ...successTeaser[0]
            })
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            infoTeaser?.length === 1 && /*#__PURE__*/ _jsx(InfoTeaser, {
                ...infoTeaser[0]
            }),
            /*#__PURE__*/ _jsxs("form", {
                action: dispatch,
                className: classNames(styles.form, {
                    [styles.spacing]: !infoTeaser?.length
                }),
                ref: formRef,
                children: [
                    /*#__PURE__*/ _jsx(RichText, {
                        elementMappers: richTextMapperOverride,
                        richText: intro
                    }),
                    /*#__PURE__*/ _jsx(Textfield, {
                        defaultValue: state.inputs.contractId,
                        errorMessage: "Bitte gib eine gültige Vertragsnummer mit 7 oder 8 Ziffern ein.",
                        forcedError: state.errors?.includes('CustomerContractNotFoundError') && !contractIdChanged && !pending ? INCORRECT_DATA_ERROR : undefined,
                        label: "Vertragsnummer",
                        maxLength: 8,
                        name: "contractId",
                        onChange: ()=>{
                            setContractIdChanged(true);
                        },
                        pattern: "\\d{7,8}",
                        required: true
                    }),
                    /*#__PURE__*/ _jsx(Textfield, {
                        defaultValue: state.inputs.counterNumber,
                        errorMessage: "Bitte gib eine gültige Zählernummer mit maximal 40 Zeichen ein.",
                        forcedError: state.errors?.includes('CounterNumberNotFoundError') && !meterIdChanged && !pending ? INCORRECT_DATA_ERROR : undefined,
                        label: "Zählernummer",
                        maxLength: 40,
                        name: "meterId",
                        onChange: ()=>{
                            setMeterIdChanged(true);
                        },
                        required: true,
                        type: "text"
                    }),
                    /*#__PURE__*/ _jsx(Textfield, {
                        defaultValue: state.inputs.emailAddress,
                        errorMessage: INCORRECT_DATA_ERROR,
                        label: "E-Mail-Adresse",
                        name: "email",
                        required: true,
                        type: "email"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(RichText, {
                            elementMappers: richTextMapperOverride,
                            richText: aknowledgement
                        })
                    }),
                    /*#__PURE__*/ _jsx(Checkbox, {
                        errorMessage: "Hier fehlt noch eine Angabe.",
                        label: /*#__PURE__*/ _jsx(Checkbox.Label, {
                            children: optin
                        }),
                        children: /*#__PURE__*/ _jsx(Checkbox.Checkbox, {
                            defaultChecked: state.inputs.optIn,
                            name: "optIn",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        name: "optInText",
                        type: "hidden",
                        value: optin
                    }),
                    state.errors?.includes('SubmitError') && !pending && /*#__PURE__*/ _jsx(FieldFooter, {
                        className: styles.error,
                        error: true,
                        icon: /*#__PURE__*/ _jsx(AlertIconXs, {}),
                        children: "Beim Senden der Anfrage ist ein unerwarteter Fehler aufgetreten. Bitte versuche es später noch einmal."
                    }),
                    /*#__PURE__*/ _jsx(BoxCTA, {
                        as: "button",
                        loading: pending,
                        type: "submit",
                        children: "Absenden"
                    }),
                    /*#__PURE__*/ _jsx(RichText, {
                        richText: privacyNote
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=KWKForm.js.map